import RsaAccettazioneListPage from "./pages/RsaAccettazioneListPage.vue";
import RsaAccettazioneEdit from "./pages/RsaAccettazioneEditPage.vue";
import RsaAccettazioneViewPage from "./pages/RsaAccettazioneViewPage.vue";
import RsaAccettazioneRicetteEditPage from "./pages/RsaAccettazioneRicetteEditPage.vue";
import RsaStoricoPostoLettoListPage from "./pages/RsaStoricoPostoLettoListPage.vue";
import RsaStoricoPostoLettoViewPage from "./pages/RsaStoricoPostoLettoViewPage.vue";

export default {
    RsaAccettazioneListPage,
    RsaAccettazioneEdit,
    RsaAccettazioneViewPage,
    RsaAccettazioneRicetteEditPage,
    RsaStoricoPostoLettoListPage,
    RsaStoricoPostoLettoViewPage
};
